import { Select } from 'primeng/select'

import { checkIsElementAttached } from '../../layout/utils'

export function patchSelect() {
  /**
   * Patch the `Select::hide` method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__Select_hide = Select.prototype.hide
  Select.prototype.hide = function (...args) {
    orig__Select_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()
      }
    }, 32)
  }

  /**
   * Path the `Select::shows` method to fix a problem focusing the selected option
   */
  const orig__Select_show = Select.prototype.show
  Select.prototype.show = function (...args) {
    setTimeout(() => {
      const focusedOptionIndex =
        this.focusedOptionIndex() !== -1
          ? this.focusedOptionIndex()
          : this.overlayVisible && this.autoOptionFocus
            ? this.findFirstFocusedOptionIndex()
            : -1

      if (focusedOptionIndex !== this.focusedOptionIndex()) {
        this.focusedOptionIndex.set(focusedOptionIndex)
      }

      if (this.overlayVisible) {
        this.scrollInView(this.focusedOptionIndex())
      }
    }, 32)

    return orig__Select_show.call(this, ...args)
  }
}
